.spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: spinner-rotate 0.8s linear infinite;
  will-change: transform;
  backface-visibility: hidden;
  transform: translateZ(0);
}

.spinner svg {
  display: block;
  width: 100%;
  height: 100%;
}

.spinner__circle {
  stroke-dasharray: 60;
  stroke-dashoffset: 45;
  stroke-linecap: round;
  animation: spinner-dash 1.5s ease-in-out infinite;
  opacity: 0.7;
  will-change: stroke-dasharray, stroke-dashoffset;
}

/* Sizes */
.spinner--xs {
  width: 12px;
  height: 12px;
}

.spinner--sm {
  width: 16px;
  height: 16px;
}

.spinner--md {
  width: 20px;
  height: 20px;
}

.spinner--lg {
  width: 32px;
  height: 32px;
}

/* Colors */
.spinner--primary {
  color: var(--primary);
}

.spinner--white {
  color: white;
}

.spinner--muted {
  color: var(--text-muted);
}

/* Animations */
@keyframes spinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
